import { useSidebar } from '@/App';
import { cn } from '@/lib/utils';

export const useSidebarLayout = () => {
  const { sidebarOpen } = useSidebar();
  
  // Common class for page headers that need to adjust to sidebar state
  const getPageHeaderClass = (additionalClasses?: string) => {
    return cn(
      "fixed top-16 left-0 right-0 z-40 bg-white border-b border-gray-200 shadow-sm h-16 transition-all duration-300",
      sidebarOpen ? "md:left-64" : "md:left-16",
      additionalClasses
    );
  };
  
  return {
    sidebarOpen,
    getPageHeaderClass
  };
};
